<template>
  <div>
    <div class="section-title">
      Paso 3. Información adicional
    </div>
    <div class="section-content">
      <div class="section-column">
        <label class="input-label">
          Calle y número
          <input class="input" type="text" v-model="data.address" />
        </label>
        <label class="input-label">
          Ciudad
          <input class="input" type="text" v-model="data.city" />
        </label>
        <div class="input-label">
          Estado
          <v-select :options="states" v-model="data.state" maxHeight="160px"></v-select>
        </div>
      </div>
      <div class="section-column">
        <div class="input-label">
          País
          <v-select :options="countries" v-model="data.country" maxHeight="340px"></v-select>
        </div>
        <label class="input-label">
          Teléfono
          <input class="input" type="text" v-model="data.phone" />
        </label>
      </div>
    </div>
    <div class="section-button">
      <div class="button" :class="[ filled ? '' : 'disabled' ]" @click="saveButton">Guardar</div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import vSelect from 'vue-select';
import states from '../../assets/states.json';
import countries from '../../assets/countries.json';

const { mapState, mapActions } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      data: {},
      states,
      countries,
      saved: false,
    };
  },
  components: {
    'v-select': vSelect,
  },
  computed: {
    filled() {
      const keys = ['address', 'city', 'state', 'country', 'phone'];
      for (let i = 0; i < keys.length; i += 1) {
        const element = keys[i];
        if (this.data[element] === null || this.data[element] === '') {
          return false;
        }
      }
      return true;
    },
    ...mapState([
      'user',
      'token',
    ]),
  },
  methods: {
    updateAction() {
      this.updateUser(this.data)
        .then(() => {
          this.saved = true;
          setTimeout(() => {
            this.saved = false;
          }, 4000);
        });
    },
    saveButton() {
      if (this.filled) {
        this.updateUser(this.data).then(() => {
          this.$emit('next');
        });
      }
    },
    ...mapActions([
      'updateUser',
      'getUser',
    ]),
  },
  mounted() {
    this.getUser().then(() => {
      this.data = { ...this.user };
    });
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: .5;
}
</style>
